"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DatePicker = _interopRequireDefault(require("./DatePicker"));

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var DateTimePicker =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(DateTimePicker, _Component);

  function DateTimePicker(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DateTimePicker);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DateTimePicker).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onDateChange", function (selectedDate) {
      _this.setState({
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onTimeChange", function (selectedTime) {
      _this.setState({
        selectedTime: selectedTime
      });
    });
    var id = props.id,
        _selectedDate = props.selectedDate,
        _selectedTime = props.selectedTime,
        tooltipType = props.tooltipType,
        tooltipMessage = props.tooltipMessage,
        tooltipPosition = props.tooltipPosition,
        updateTooltipPositionOnMove = props.updateTooltipPositionOnMove,
        onTooltipHidden = props.onTooltipHidden;

    if (!id) {
      throw new Error("The prop 'id' is required to make DateTimePicker accessible for users using assistive technologies such as screen readers. Check the render method of DateTimePicker.");
    }

    if (tooltipType || tooltipMessage || tooltipPosition || updateTooltipPositionOnMove || onTooltipHidden) {
      throw new Error('Tooltip support inside of DateTimePicker was removed in v6.0.0. Use dateNode and timeNode getters in a parent component to add tooltips manually as necessary.');
    }

    _this.state = {
      selectedDate: _selectedDate,
      selectedTime: _selectedTime
    };
    return _this;
  }

  (0, _createClass2.default)(DateTimePicker, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var onChange = this.props.onChange;
      var _this$state = this.state,
          selectedDate = _this$state.selectedDate,
          selectedTime = _this$state.selectedTime;
      var prevSelectedDate = prevState.selectedDate,
          prevSelectedTime = prevState.selectedTime;

      if ((selectedDate !== prevSelectedDate || selectedTime !== prevSelectedTime) && onChange) {
        onChange({
          selectedDate: selectedDate,
          selectedTime: selectedTime
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          id = _this$props.id,
          useIcons = _this$props.useIcons,
          dateLabel = _this$props.dateLabel,
          datePlaceholder = _this$props.datePlaceholder,
          timeLabel = _this$props.timeLabel,
          timePlaceholder = _this$props.timePlaceholder,
          dateName = _this$props.dateName,
          timeName = _this$props.timeName,
          timeStep = _this$props.timeStep,
          calendarClassName = _this$props.calendarClassName,
          overrideInitialMonthWithSelected = _this$props.overrideInitialMonthWithSelected,
          disablePast = _this$props.disablePast,
          disableDateBefore = _this$props.disableDateBefore,
          disableDateAfter = _this$props.disableDateAfter,
          disableTimeBefore = _this$props.disableTimeBefore,
          disableTimeAfter = _this$props.disableTimeAfter,
          useTetherShim = _this$props.useTetherShim,
          disabled = _this$props.disabled;
      var _this$state2 = this.state,
          selectedDate = _this$state2.selectedDate,
          selectedTime = _this$state2.selectedTime;
      var classes = (0, _classnames.default)('DateTimePicker', className);
      return _react.default.createElement("div", {
        className: classes
      }, _react.default.createElement(_DatePicker.default, {
        ref: function ref(node) {
          _this2._datePicker = node;
        },
        id: id,
        name: dateName,
        calendarClassName: calendarClassName,
        useIcon: useIcons,
        disabled: disabled,
        label: dateLabel,
        placeholder: datePlaceholder,
        selectedDate: selectedDate,
        overrideInitialMonthWithSelected: overrideInitialMonthWithSelected,
        onChange: this._onDateChange,
        disablePast: disablePast,
        disableBefore: disableDateBefore,
        disableAfter: disableDateAfter,
        useTetherShim: useTetherShim
      }), _react.default.createElement(_TimePicker.default, {
        ref: function ref(node) {
          _this2._timePicker = node;
        },
        name: timeName,
        useIcon: useIcons,
        disabled: disabled,
        label: timeLabel,
        placeholder: timePlaceholder,
        selectedTime: selectedTime,
        step: timeStep,
        disableBefore: disableTimeBefore,
        disableAfter: disableTimeAfter,
        onChange: this._onTimeChange
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "dateNode",

    /**
     * Getter for the date picker input DOM element.
     *
     * @public
     * @returns {Element} - The input element.
     */
    get: function get() {
      return this._datePicker.node;
    }
    /**
     * Getter for the time picker select DOM element.
     *
     * @public
     * @returns {Element} - The select element.
     */

  }, {
    key: "timeNode",
    get: function get() {
      return this._timePicker.node;
    }
  }]);
  return DateTimePicker;
}(_react.Component);

exports.default = DateTimePicker;
(0, _defineProperty2.default)(DateTimePicker, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique ID which is used to identify this element for accessibility purposes on the client as well as the server. */
  id: _propTypes.default.string.isRequired,

  /** Additional class(es) to add to the the underlying calendar component. */
  calendarClassName: _propTypes.default.string,

  /** Whether to show the calendar and clock icons in the selectors. */
  useIcons: _propTypes.default.bool,

  /** Whether the DateTimePicker is disabled or not. */
  disabled: _propTypes.default.bool,

  /** A unique name which is used to identify the date element. If belonging to a form this is used as the key for serialization and is required. */
  dateName: _propTypes.default.string,

  /** A unique name which is used to identify the time element. If belonging to a form this is used as the key for serialization and is required. */
  timeName: _propTypes.default.string,

  /** A custom label (typically a Label component) to display above the date input. */
  dateLabel: _propTypes.default.element,

  /** A placeholder to display in the date input. */
  datePlaceholder: _propTypes.default.string,

  /** A custom label (typically a Label component) to display above the time selector. */
  timeLabel: _propTypes.default.element,

  /** A placeholder to display in the time input. */
  timePlaceholder: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date which should be selected. */
  selectedDate: _propTypes.default.string,

  /** A string in the format of 'hh:mm A' representing the time which should be selected. */
  selectedTime: _propTypes.default.string,

  /** Whether to set the initial month to show in the calendar to the same month as the selected day falls within when a day is selected. */
  overrideInitialMonthWithSelected: _propTypes.default.bool,

  /** The multiplier with which to create selectable times in the dropdown (in minutes). */
  timeStep: _propTypes.default.number,

  /**
   * Where the applicable tooltip should be anchored to.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  tooltipType: _propTypes.default.oneOf(['none', 'date', 'time']),

  /**
   * The message to display inside of the tooltip.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  tooltipMessage: _propTypes.default.string,

  /**
   * Where to position the tooltip in relation to the triggering element.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  tooltipPosition: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Whether to reposition the tooltip when it moves, be it via window resize or scrolling or whatever moves it.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  updateTooltipPositionOnMove: _propTypes.default.bool,

  /** Whether to disable days before today. */
  disablePast: _propTypes.default.bool,

  /** A string in the format 'MM/DD/YYYY' representing the date where days before it should be disabled in the calendar. */
  disableDateBefore: _propTypes.default.string,

  /** A string in the format 'MM/DD/YYYY' representing the date where days after it should be disabled in the calendar. */
  disableDateAfter: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times before it should be disabled in the selector. */
  disableTimeBefore: _propTypes.default.string,

  /** A string in the format 'hh:mm A' representing the time where times after it should be disabled in the selector. */
  disableTimeAfter: _propTypes.default.string,

  /** Puts the calendar in the center of the page with a shim behind it. */
  useTetherShim: _propTypes.default.bool,

  /**
   * A function to execute after the tooltip has been hidden.
   *
   * @deprecated Tooltip support was removed in v6.0.0.
   */
  onTooltipHidden: _propTypes.default.func,

  /**
   * Function to execute when the selected date and/or time changes.
   *
   * @param {String} selectedDate - The selected date in the format 'MM/DD/YYYY'.
   * @param {String} selectedTime - The selected time in the format 'hh:mm A'.
   */
  onChange: _propTypes.default.func
});
(0, _defineProperty2.default)(DateTimePicker, "defaultProps", {
  useIcons: true,
  timeStep: 30,
  disablePast: true,
  overrideInitialMonthWithSelected: true
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(DateTimePicker, "DateTimePicker", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/DateTime/DateTimePicker.jsx");
  leaveModule(module);
})();

;